import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from '../../../../../components/Skeleton';

const USAGE_PERCENTAGE_LOW_ALERT_THRESHOLD = 70;
const USAGE_PERCENTAGE_HIGH_ALERT_THRESHOLD = 85;

const BaseUsageCard = css`
  flex-grow: 1;
  height: 160px;
  padding: 24px;
  border-radius: 4px;
  max-width: none;
  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export const ErrorUsageCardWrapper = styled.div`
  ${BaseUsageCard}
  padding: 0;
  width: min-content;
`;

export const LoadingUsageCard = styled(Skeleton)`
  ${BaseUsageCard}
`;

export const UsageCard = styled.div`
  ${BaseUsageCard}
  background-color: ${globals.WHITE};
  color: ${globals.MOON_800};
  border: 1px solid ${globals.MOON_200};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const UsageWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

export const UsageLimit = styled.div`
  font-size: 16px;
  color: ${globals.gray400};
  font-weight: 600;
`;

export const UsageUnit = styled.div`
  font-size: 16px;
  color: ${globals.gray800};
  font-weight: 600;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${globals.gray500};
`;

export const OuterBar = styled.div`
  height: 6px;
  line-height: 24px;
  background-color: ${globals.gray300};
  border-radius: 8px;
  position: relative;
`;

export const InnerBar = styled.div<{percentage: number; color: string}>`
  height: 6px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 8px;
  background-color: ${props => props.color};
  width: ${props => props.percentage}%;
`;

export const Usage = styled.div<{percentage: number}>`
  color: ${props => getUsageColor(globals.MOON_800, props.percentage)};
  font-size: 40px;
  font-weight: 400;
  line-height: 48px;
`;

export function getUsageColor(defaultColor: string, percentage: number) {
  if (percentage >= USAGE_PERCENTAGE_HIGH_ALERT_THRESHOLD) {
    return globals.RED_500;
  }
  if (percentage >= USAGE_PERCENTAGE_LOW_ALERT_THRESHOLD) {
    return globals.GOLD_500;
  }
  return defaultColor;
}

export const PayAsYouGo = styled.div`
  color: ${globals.gray500};
  font-style: italic;
`;
